import React from "react";
import "./App.css";
import Footer from "./components/lib/common/Footer";
import { AppProvider, useAppContext } from "./AppContext";

import {
  BrowserRouter,
  Routes,
  Route,
  Router,
  Navigate,
  useLocation,
} from "react-router-dom";

import { ModalProvider } from "./components/lib/modal/ModalContext";
import { AuthProvider } from "./components/lib/hook/AuthProvider";
import CRUDFeature from "./components/last-resort-of-tcms-front/CRUDFeature";
import { APIProvider } from "./components/lib/hook/APIProvider";
import HsCodeUpdateForVehicleItem from "./components/last-resort-of-tcms-front/HsCodeUpdateForVehicleItem";
import ReportBatchRemover from "./components/last-resort-of-tcms-front/ReportBatchRemover";
import LoginPage from "./components/last-resort-of-tcms-front/LoginPage";
import RequireToken from "./components/lib/common/RequireToken";

import KPIDownloadModal from "./components/last-resort-of-tcms-front/KPIDownloadModal";
import DeleteACar from "./components/last-resort-of-tcms-front/DeleteACar";
import GetImpVehicleByInvs from "./components/last-resort-of-tcms-front/GetImpVehicleByInvs";
function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <APIProvider>

            <ModalProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/GetImpVehicleByInvs" element={<GetImpVehicleByInvs />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route
                    path="/"
                    element={

                        <CRUDFeature />
         
                    }
                  />
                  
                  <Route
                    path="/kpi"
                    element={

                        <KPIDownloadModal />
                 
                    }
                  />
                  <Route
                    path="/change-hs"
                    element={
 
                        <HsCodeUpdateForVehicleItem />
      
                    }
                  />
                  <Route
                    path="/report-batch-remover"
                    element={

                        <ReportBatchRemover />
        
                    }
                  />
                  <Route
                    path="/delete-car"
                    element={

                        <DeleteACar/>
           
                    }
                  />
                </Routes>
              </BrowserRouter>
            </ModalProvider>

          </APIProvider>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
